(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-open.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-open.js');

'use strict';

const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  PixArea = _svs$components$marke.PixArea,
  PlayButton = _svs$components$marke.PlayButton,
  Registration = _svs$components$marke.Registration,
  VisitGameButton = _svs$components$marke.VisitGameButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.helpers,
  capitalize = _svs$components$marke2.capitalize,
  ordinalNumber = _svs$components$marke2.ordinalNumber;
const useMobileQuery = svs.components.marketplaceCompetition.overviewHero.hooks.useMobileQuery;
const _svs$components$marke3 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke3.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke3.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke3.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition,
    compName = _ref.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  var _competition$currentD;
  let competition = _ref3.competition;
  const _ref4 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref4.firstDrawNumber,
    currentDrawNumber = _ref4.currentDrawNumber;
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "L\xE4mna in ditt spel till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "L\xE4mna in ditt spel till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "L\xE4mna in ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("p", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(PlayButton, {
    competition: competition
  })));
};
const UserHasBet = _ref5 => {
  var _competition$currentD2;
  let competition = _ref5.competition;
  const _ref6 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref6.firstDrawNumber,
    currentDrawNumber = _ref6.currentDrawNumber;
  const closeTime = (_competition$currentD2 = competition.currentDraw) !== null && _competition$currentD2 !== void 0 && _competition$currentD2.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "Du har l\xE4mnat in spelet till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "Du har l\xE4mnat in spelet till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("h2", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("p", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionOpenDrawOpen = _ref7 => {
  let branding = _ref7.branding,
    competition = _ref7.competition,
    userState = _ref7.userState;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-open', userState)
  }, renderContentBasedOnUserState(userState)), React.createElement(PixArea, {
    branding: branding,
    competition: competition,
    isMobile: isMobile,
    isVisible: userState === HAS_NO_CURRENT_BET
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawOpen', CompetitionOpenDrawOpen);

 })(window);